var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChart48Filled = function SvgIconChart48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.37 9.3H14.6a5.3 5.3 0 0 0-5.3 5.3v18.8a5.31 5.31 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3V14.6a5.3 5.3 0 0 0-5.33-5.3ZM19.67 32h-3.4v-8h3.4v8Zm6 0h-3.4V16h3.4v16Zm6 0h-3.4V22h3.4v10Z",
    fill: "current"
  })));
};
export default SvgIconChart48Filled;